var _filter, _rect, _rect2, _text, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgPerformanceSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 420",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg6",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar1Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f97316"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar2Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6c63ff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar3Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#10b981"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 420,
    rx: 16,
    fill: "url(#bg6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 420,
    rx: 16,
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 38,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 20,
    fontWeight: 700,
    opacity: 0
  }, "\n    \uD83D\uDCCA Performance Comparison Summary\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 65,
    x2: 260,
    y2: 310,
    stroke: "#475569",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 65,
    x2: 370,
    y2: 310,
    stroke: "#475569",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 65,
    x2: 480,
    y2: 310,
    stroke: "#475569",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590,
    y1: 65,
    x2: 590,
    y2: 310,
    stroke: "#475569",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 65,
    x2: 660,
    y2: 310,
    stroke: "#475569",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fontSize: 9,
    fill: "#475569"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.6,
    dur: "0.4s",
    begin: "0.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 320,
    textAnchor: "middle"
  }, "20K"), /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 320,
    textAnchor: "middle"
  }, "40K"), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 320,
    textAnchor: "middle"
  }, "60K"), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 320,
    textAnchor: "middle"
  }, "80K"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 320,
    textAnchor: "middle"
  }, "100K"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.4s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 100,
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Express"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 117,
    fill: "#94a3b8",
    fontSize: 10
  }, "(Single Thread)"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 85,
    width: 510,
    height: 42,
    rx: 6,
    fill: "#1e1e3a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 85,
    width: 0,
    height: 42,
    rx: 6,
    fill: "url(#bar1Grad)",
    filter: "url(#glow6)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    from: 0,
    to: 64,
    dur: "1s",
    begin: "0.6s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    begin: "1.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 112,
    fill: "#fca5a5",
    fontSize: 14,
    fontWeight: 700
  }, "10,835 RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 97,
    width: 65,
    height: 22,
    rx: 6,
    fill: "#1e1e3a",
    stroke: "#6b7280",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 113,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontWeight: 600
  }, "Baseline")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 180,
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Express"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 197,
    fill: "#94a3b8",
    fontSize: 10
  }, "+ Clustering"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 165,
    width: 510,
    height: 42,
    rx: 6,
    fill: "#1e1e3a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 165,
    width: 0,
    height: 42,
    rx: 6,
    fill: "url(#bar2Grad)",
    filter: "url(#glow6)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    from: 0,
    to: 310,
    dur: "1.2s",
    begin: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    begin: "2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 192,
    fill: "#93c5fd",
    fontSize: 14,
    fontWeight: 700
  }, "52,588 RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 177,
    width: 55,
    height: 22,
    rx: 6,
    fill: "#1e1e3a",
    stroke: "#3b82f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 602,
    y: 193,
    textAnchor: "middle",
    fill: "#60a5fa",
    fontSize: 10,
    fontWeight: 700
  }, "4.8x")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 260,
    fill: "#e2e8f0",
    fontSize: 12,
    fontWeight: 600
  }, "Fastify"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 277,
    fill: "#94a3b8",
    fontSize: 10
  }, "+ Clustering"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 245,
    width: 510,
    height: 42,
    rx: 6,
    fill: "#1e1e3a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 245,
    width: 0,
    height: 42,
    rx: 6,
    fill: "url(#bar3Grad)",
    filter: "url(#glow6)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    from: 0,
    to: 510,
    dur: "1.5s",
    begin: "1.4s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    begin: "2.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 272,
    fill: "#86efac",
    fontSize: 14,
    fontWeight: 700
  }, "86,516 RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 257,
    width: 55,
    height: 22,
    rx: 6,
    fill: "#0a1f0a",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    filter: "url(#glow6)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 602,
    y: 273,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 10,
    fontWeight: 700
  }, "8x \uD83C\uDFC6")), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 266,
    r: 3,
    fill: "#22c55e",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1.5s",
    begin: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2;5;2",
    dur: "1.5s",
    begin: "3s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "2.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 335,
    width: 195,
    height: 65,
    rx: 10,
    fill: "#1a0a0a",
    stroke: "#ef4444",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 360,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83D\uDC0C Without Optimization"), /*#__PURE__*/React.createElement("text", {
    x: 137,
    y: 383,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 16,
    fontWeight: 700
  }, "10,835 RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 335,
    width: 195,
    height: 65,
    rx: 10,
    fill: "#0a0a1f",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 349,
    y: 360,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 11,
    fontWeight: 600
  }, "\u26A1 With Clustering"), /*#__PURE__*/React.createElement("text", {
    x: 349,
    y: 383,
    textAnchor: "middle",
    fill: "#818cf8",
    fontSize: 16,
    fontWeight: 700
  }, "52,588 RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 335,
    width: 195,
    height: 65,
    rx: 10,
    fill: "#0a1f0a",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    opacity: 0.8,
    filter: "url(#glow6)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 561,
    y: 360,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83D\uDE80 Fastify + Cluster"), /*#__PURE__*/React.createElement("text", {
    x: 561,
    y: 383,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 16,
    fontWeight: 700
  }, "86,516 RPS"), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 367,
    x2: 252,
    y2: 367,
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeDasharray: "3,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 10,
    to: 0,
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 447,
    y1: 367,
    x2: 464,
    y2: 367,
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeDasharray: "3,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 10,
    to: 0,
    dur: "0.8s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPerformanceSummary);
export default __webpack_public_path__ + "static/media/svg-performance-summary.de83f11bf515baaca398a8a4969c928c.svg";
export { ForwardRef as ReactComponent };